import { apiCreatePage, apiEditPage, apiGetPages, apiDeletePage } from '@/api/templates'
import { apiGetBindingsTemplateToObject,
  apiCreateBindingTemplateToObject,
  apiEditBindingTemplateToObject,
  apiDeleteBindingTemplateToObject } from '@/api/bindings'
import { apiLogin } from '@/api/auth'
import { apiGetObjects, apiUpdateObject, apiActivateObject, apiDeactivateObject } from '@/api/objects'
import { apiGetRedirects, apiCreateRedirect, apiUpdateRedirect, apiRedirectDelete } from '@/api/redirect'

const actions = {
  'LOGIN' ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiLogin(payload.username, payload.password)
        .then(response => {
          commit('LOGIN', { username: payload.username, token: response.data.token })
          resolve(response)
        })
        .catch(e => reject(e))
    })
  },
  'OBJECTS_GET' ({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGetObjects(state.user.token)
        .then(response => {
          commit('OBJECTS_GET', response.data)
          resolve(response)
        })
        .catch(e => reject(e))
    })
  },
  'OBJECT_UPDATE' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      apiUpdateObject(payload, state.user.token)
        .then(() => resolve())
        .catch(e => reject(e))
    })
  },
  'TEMPLATES_GET' ({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGetPages(state.user.token)
        .then(response => {
          commit('TEMPLATES_GET', response.data.results)
          resolve(response)
        })
        .catch(e => reject(e))
    })
  },
  'TEMPLATE_CREATE' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      apiCreatePage(payload, state.user.token)
        .then(response => resolve(response))
        .catch(e => reject(e))
    })
  },
  'TEMPLATE_UPDATE' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      apiEditPage(payload.id, payload.data, state.user.token)
        .then(response => resolve(response))
        .catch(e => reject(e))
    })
  },
  'TEMPLATE_DELETE' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      apiDeletePage(payload, state.user.token)
        .then(response => resolve(response))
        .catch(e => reject(e))
    })
  },
  'REDIRECTS_GET' ({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGetRedirects(state.user.token)
        .then(response => {
          commit('REDIRECTS_GET', response.data.results)
          resolve(response)
        })
        .catch(e => reject(e))
    })
  },
  'REDIRECT_CREATE' ({state}, payload) {
    return new Promise((resolve, reject) => {
      apiCreateRedirect(payload, state.user.token)
        .then(response => resolve(response))
        .catch(e => reject(e))
    })
  },
  'REDIRECT_UPDATE' ({state}, payload) {
    return new Promise((resolve, reject) => {
      apiUpdateRedirect(payload, state.user.token)
        .then(response => resolve(response))
        .catch(e => reject(e))
    })
  },
  'REDIRECT_DELETE' ({state}, payload) {
    return new Promise((resolve, reject) => {
      apiRedirectDelete(payload, state.user.token)
        .then(response => resolve(response))
        .catch(e => reject(e))
    })
  },
  'BINDINGS_GET' ({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGetBindingsTemplateToObject(state.user.token)
        .then(response => {
          commit('BINDINGS_GET', response.data.results)
          resolve(response)
        })
        .catch(e => reject(e))
    })
  },
  'BINDINGS_CREATE' ({state}, payload) {
    return new Promise((resolve, reject) => {
      apiCreateBindingTemplateToObject(payload.data, state.user.token)
        .then(() => resolve())
        .catch(e => reject(e))
    })
  },
  'BINDINGS_UPDATE' ({state}, payload) {
    return new Promise((resolve, reject) => {
      apiEditBindingTemplateToObject(payload.id, payload.data, state.user.token)
        .then(() => resolve())
        .catch(e => reject(e))
    })
  },
  'BINDINGS_DELETE' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      apiDeleteBindingTemplateToObject(payload.id, state.user.token)
        .then(() => resolve())
        .catch(e => reject(e))
    })
  },
  'OBJECTS_ACTIVATE' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      apiActivateObject(payload, state.user.token)
        .then(response => resolve(response))
        .catch(e => reject(e))
    })
  },
  'OBJECTS_DEACTIVATE' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      apiDeactivateObject(payload, state.user.token)
        .then(response => resolve(response))
        .catch(e => reject(e))
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js